import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { AppConsts } from '@application/common/constants/app-consts';
import { addAttachmentsByOrderIdAsync, createOrderAsync, createProgressNotesByIdAsync, deleteOrderAttachmentAsync, deleteOrderByIdAsync, deleteProgressNotesByIdAsync, generateOrderPdfAsAttachmentAsync, generateOrderPdfAsync, generatePriceRequestPdfAsAttachmentAsync, generatePriceRequestPdfAsync, getAllAttachmentsByOrderIdAsync, getAllCreditorsAsync, getAllOrderAsync, getAllOrderStatusAsync, getAllProgressNotesByOrderIdAsync, getContactPersonsByIdAsync, getOrderByIdAsync, getOrderNumberAsync, getWorkOrdersListWithClientAsync, updateOrderAsync, updateOrderStatusByIdAsync } from './orderThunk';
const orderRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE
};
const initialState = {
    status: APIStatus.IDLE,
    orderRequest: orderRequest
};
export const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setWorkOrderNumberAtOrder: (state, action) => {
            state.WorkOrderNumber = action.payload;
        },
        setSelectedWorkorderCalculationToOrderItemsList: (state, action) => {
            state.SelectedWorkorderCalculationsToOrderItemIdsList = action.payload;
        },
        clearSelectedWorkorderCalculationToOrderItemsList: (state) => {
            state.SelectedWorkorderCalculationsToOrderItemIdsList = null;
        },
        setSelectedCalculationForPurchaseInovice: (state, action) => {
            state.SelectedCalculationForPurchaseInvoice = action.payload;
        },
        clearSelectedCalculationForPurchaseInovice: (state) => {
            state.SelectedCalculationForPurchaseInvoice = null;
        },
        setOrderNumberForPurchaseInvoice: (state, action) => {
            state.OrderNumberForPurchaseInvoice = action.payload;
        },
        clearOrderNumberForPurchaseInvoice: (state) => {
            state.OrderNumberForPurchaseInvoice = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getOrderNumberAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getOrderNumberAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.ordernumber = action.payload;
        })
            .addCase(getOrderNumberAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createOrderAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createOrderAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.CreateOrder = action.payload;
        })
            .addCase(createOrderAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getOrderByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getOrderByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.Order = action.payload;
            state.unchangedOrder = action.payload;
        })
            .addCase(getOrderByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllCreditorsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllCreditorsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.creditors = action.payload;
            state.creditorDropdown = action.payload.map((creditor) => {
                return {
                    label: `${creditor.name}`,
                    value: creditor.id
                };
            });
            state.activeCreditorDropdown = action.payload
                .filter((x) => !x.expired)
                .map((creditor) => {
                return {
                    label: `${creditor.name}`,
                    value: creditor.id
                };
            });
        })
            .addCase(getAllCreditorsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getContactPersonsByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getContactPersonsByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.contactPerson = action.payload;
            state.contactPersonDropdown = action.payload.map((contactperson) => {
                return {
                    label: `${contactperson.firstName ? contactperson.firstName : ''} ${contactperson.lastName ? contactperson.lastName : ''}`,
                    value: contactperson.id,
                    number: `${contactperson.phoneNumber ? contactperson.phoneNumber : ''}`
                };
            });
        })
            .addCase(getContactPersonsByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getWorkOrdersListWithClientAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getWorkOrdersListWithClientAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.WorkOrderListWithClient = action.payload;
            state.WorkOrderListWithClientOptions = action.payload.map((workOrder) => {
                return {
                    label: workOrder.workOrderNumber,
                    value: workOrder.id
                };
            });
        })
            .addCase(getWorkOrdersListWithClientAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllOrderStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllOrderStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.OrderStatus = action.payload;
            state.OrderStatusDropdown = action.payload.map((status) => {
                return {
                    label: `${status.status}`,
                    value: status.id
                };
            });
        })
            .addCase(getAllOrderStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateOrderAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateOrderAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.UpdateOrder = action.payload;
        })
            .addCase(updateOrderAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllOrderAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllOrderAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.orders = action.payload;
        })
            .addCase(getAllOrderAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllProgressNotesByOrderIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllProgressNotesByOrderIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.orderProgressNotes = action.payload;
        })
            .addCase(getAllProgressNotesByOrderIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteProgressNotesByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteProgressNotesByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.deleteProgressNotes = action.payload;
        })
            .addCase(deleteProgressNotesByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createProgressNotesByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createProgressNotesByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.orderProgressNote = action.payload;
        })
            .addCase(createProgressNotesByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllAttachmentsByOrderIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllAttachmentsByOrderIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.orderAttachments = action.payload;
        })
            .addCase(getAllAttachmentsByOrderIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(addAttachmentsByOrderIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(addAttachmentsByOrderIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.uploadAttachment = action.payload;
        })
            .addCase(addAttachmentsByOrderIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteOrderAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteOrderAttachmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.deleteAttachment = action.payload;
        })
            .addCase(deleteOrderAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteOrderByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteOrderByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteOrderByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generatePriceRequestPdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generatePriceRequestPdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generatePriceRequestPdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateOrderPdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateOrderPdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateOrderPdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateOrderStatusByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateOrderStatusByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updatedOrderStatusByIdResponse = action.payload;
        })
            .addCase(updateOrderStatusByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateOrderPdfAsAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateOrderPdfAsAttachmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateOrderPdfAsAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generatePriceRequestPdfAsAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generatePriceRequestPdfAsAttachmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generatePriceRequestPdfAsAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default orderSlice.reducer;
export const { setWorkOrderNumberAtOrder, setSelectedWorkorderCalculationToOrderItemsList, clearSelectedWorkorderCalculationToOrderItemsList, clearOrderNumberForPurchaseInvoice, setOrderNumberForPurchaseInvoice, clearSelectedCalculationForPurchaseInovice, setSelectedCalculationForPurchaseInovice } = orderSlice.actions;
